import {EventTemplateStatus} from "../../../../shared/enums/eventTemplateStatus";

/**
 * Represents an event template summary of an event template category in the event catalogue.
 */
export default class EventTemplateSummaryItem {
  id: string;
  title: string;
  description: string;
  lastEditedDate: Date;
  status: EventTemplateStatus;
  imageId: string;
  isVillageFavourite: boolean;
  image: string;
  category: string;
  isNew: boolean;

  constructor(
    id: string,
    title: string,
    description: string,
    lastEditedDate: Date,
    status: EventTemplateStatus,
    imageId: string,
    category: string,
    isVillageFavourite: boolean,
    isNew: boolean,
    image?: string
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.lastEditedDate = lastEditedDate;
    this.status = status;
    this.imageId = imageId;
    this.image = image || "";
    this.category = category;
    this.isNew = isNew;
    this.isVillageFavourite = isVillageFavourite;
  }
}
